var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _ellipse, _ellipse2, _path14, _path15, _ellipse3, _path16, _ellipse4, _path17, _path18, _ellipse5, _path19, _ellipse6, _path20, _path21, _ellipse7, _path22, _ellipse8, _path23, _path24, _ellipse9, _ellipse10, _path25, _path26;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgStarCoins = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 252,
    height: 218,
    viewBox: "0 0 252 218",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0241 49.3941C-31.1238 93.1155 19.0207 153.559 51.2364 178.316C96.4368 213.051 200.962 246.297 244.42 178.316C292.685 102.814 97.4591 -5.25768 26.0241 49.3941Z",
    fill: "#F4F5F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M140.698 19.3199C140.838 19.5516 140.978 19.7832 141.086 20.0036C141.129 20.0917 141.183 20.1471 141.226 20.2352C141.312 20.4115 141.431 20.5991 141.517 20.7754C145.863 29.4586 142.678 40.0951 134.087 44.9105C125.904 49.4997 115.749 47.1397 110.371 39.751C109.949 39.1656 109.538 38.5475 109.171 37.908C109.031 37.6763 108.923 37.456 108.794 37.1915C108.687 36.9712 108.546 36.7395 108.45 36.4864C108.106 35.7812 107.85 35.0331 107.616 34.3291C107.297 33.2295 107.056 32.1196 106.924 31.0109C106.53 27.5752 107.145 24.0837 108.612 20.9954C110.18 17.7217 112.73 14.8965 116.148 12.957C124.761 8.18568 135.558 11.0235 140.698 19.3199Z",
    fill: "#F8D49D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M141.09 34.2714C139.758 38.1395 137.084 41.3254 133.489 43.3508C129.618 45.5379 125.105 46.0741 120.828 44.8582C116.552 43.6424 112.971 40.8327 110.815 36.9737C108.626 33.1034 108.089 28.5917 109.304 24.3168C110.519 20.0418 113.329 16.4626 117.189 14.3082C121.048 12.1538 125.573 11.585 129.849 12.8008C134.126 14.0166 137.706 16.8263 139.862 20.6853C142.051 24.5556 142.588 29.0673 141.373 33.3422C141.293 33.6813 141.191 33.9764 141.09 34.2714ZM110.538 23.715C110.437 24.0101 110.335 24.3051 110.267 24.6114C109.13 28.6569 109.627 32.8612 111.708 36.5111C113.756 40.1498 117.097 42.8036 121.144 43.9404C125.191 45.0772 129.397 44.5819 133.047 42.5022C136.686 40.4552 139.34 37.1156 140.476 33.0702C141.613 29.0247 141.116 24.8204 139.035 21.1705C136.987 17.5318 133.646 14.878 129.599 13.7412C125.552 12.6044 121.346 13.0997 117.696 15.1794C114.288 17.0861 111.791 20.0764 110.538 23.715Z",
    fill: "#F2AE43"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M113.065 28.9456L120.483 25.1931L121.627 16.9703L127.448 22.8613L135.644 21.43L131.821 28.8038L135.764 36.1015L127.562 34.7807L121.801 40.7536L120.553 32.5508L113.065 28.9456Z",
    fill: "#F2AE43"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.814 9.19122L88.814 56.0062",
    stroke: "#E3E3E3",
    strokeWidth: 1.21677,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M150.844 1L150.844 67.7113",
    stroke: "#E3E3E3",
    strokeWidth: 1.21677,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M156.695 11.5332L156.695 53.6667",
    stroke: "white",
    strokeWidth: 1.21677,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M192.977 24.4083L192.977 71.2233",
    stroke: "white",
    strokeWidth: 1.21677,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M174.251 82.9274L174.251 126.231",
    stroke: "#E3E3E3",
    strokeWidth: 1.21677,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M200 43.1365L200 78.2478",
    stroke: "white",
    strokeWidth: 1.21677,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M104.029 94.6297L104.029 151.978",
    stroke: "#E3E3E3",
    strokeWidth: 1.21677,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M112.221 115.7L112.221 155.492",
    stroke: "#E3E3E3",
    strokeWidth: 1.21677,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7915 34.9379L81.7915 56.0046",
    stroke: "#E3E3E3",
    strokeWidth: 1.21677,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.6751,
    cy: 90.7895,
    rx: 25.6751,
    ry: 21.3959,
    fill: "#EBBC73"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.6751,
    cy: 87.9391,
    rx: 25.6751,
    ry: 21.3959,
    fill: "#F8D49D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1624 91.7448L61.2562 85.7982L59.1166 77.2398L67.7499 80.9557L76.1416 77.9587L73.744 86.3504L79.738 90.9559L70.8585 92.4428L66.9502 99.9915L64.1535 92.4428L55.1624 91.7448Z",
    fill: "#F2AE43"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M90.091 87.9367C90.091 97.8792 80.1375 106.074 67.6743 106.074C55.2112 106.074 45.2576 97.8792 45.2576 87.9367C45.2576 77.9943 55.2112 69.7992 67.6743 69.7992C80.1375 69.7992 90.091 77.9943 90.091 87.9367Z",
    stroke: "#F4B85B",
    strokeWidth: 0.811179
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 142.27,
    cy: 86.6172,
    rx: 8.12871,
    ry: 25.4294,
    transform: "rotate(56.2306 142.27 86.6172)",
    fill: "#EBBC73"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M117.34 94.7881L121.699 101.327L163.839 72.9915L158.753 66.4525L117.34 94.7881Z",
    fill: "#EBBC73"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 139.05,
    cy: 81.5845,
    rx: 8.12871,
    ry: 25.4294,
    transform: "rotate(56.2306 139.05 81.5845)",
    fill: "#F8D49D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M134.67 77.2852L139.91 77.285L146.966 73.7189L145.002 78.5188L148.715 80.2953L141.358 82.9704L138.137 88.1143L136.131 84.7704L129.32 86.9835L134.67 80.9639L134.67 77.2852Z",
    fill: "#F2AE43"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M142.125 86.8936C137.024 90.3042 131.993 92.7444 127.99 93.9389C125.986 94.5369 124.262 94.8157 122.927 94.7608C121.582 94.7055 120.721 94.3179 120.299 93.686C119.876 93.0541 119.847 92.1105 120.31 90.8459C120.769 89.5914 121.685 88.1053 123.003 86.4818C125.636 83.2389 129.814 79.5215 134.914 76.1109C140.015 72.7003 145.047 70.26 149.049 69.0656C151.053 68.4676 152.777 68.1888 154.112 68.2437C155.457 68.2989 156.318 68.6866 156.74 69.3185C157.163 69.9504 157.192 70.894 156.729 72.1586C156.27 73.4131 155.354 74.8992 154.036 76.5226C151.403 79.7656 147.225 83.483 142.125 86.8936Z",
    stroke: "#F4B85B",
    strokeWidth: 0.811179
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 89.0162,
    cy: 167.189,
    rx: 7.29615,
    ry: 22.8248,
    transform: "rotate(124.152 89.0162 167.189)",
    fill: "#EBBC73"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8102 149.208L69.8421 155.041L107.628 180.531L111.351 174.094L73.8102 149.208Z",
    fill: "#EBBC73"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.1139,
    cy: 162.813,
    rx: 7.29615,
    ry: 22.8248,
    transform: "rotate(124.152 92.1139 162.813)",
    fill: "#F8D49D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2138 157.718L95.9817 162.076L101.329 166.742L96.6738 166.728L96.4486 170.415L91.7415 165.198L86.3765 164.255L88.4809 161.458L84.3421 156.54L91.154 158.959L94.2138 157.718Z",
    fill: "#F2AE43"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M88.756 167.128C84.2008 164.038 80.477 160.679 78.1362 157.757C76.9642 156.294 76.1539 154.959 75.7514 153.836C75.3452 152.703 75.3817 151.872 75.7537 151.324C76.1257 150.776 76.884 150.435 78.0868 150.393C79.2787 150.352 80.8189 150.611 82.6118 151.159C86.1925 152.254 90.6902 154.472 95.2454 157.562C99.8006 160.652 103.524 164.011 105.865 166.934C107.037 168.397 107.847 169.732 108.25 170.855C108.656 171.988 108.62 172.818 108.248 173.367C107.876 173.915 107.117 174.256 105.915 174.298C104.723 174.339 103.182 174.079 101.39 173.531C97.8088 172.437 93.3111 170.219 88.756 167.128Z",
    stroke: "#F4B85B",
    strokeWidth: 0.811179
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 182.682,
    cy: 124.965,
    rx: 6.08358,
    ry: 19.0315,
    transform: "rotate(-36.0027 182.682 124.965)",
    fill: "#EBBC73"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M189.519 143.368L194.282 139.917L171.862 109.23L167.12 113.224L189.519 143.368Z",
    fill: "#EBBC73"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 179.014,
    cy: 127.518,
    rx: 6.08358,
    ry: 19.0315,
    transform: "rotate(-36.0027 179.014 127.518)",
    fill: "#F8D49D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M175.925 130.917L175.772 126.999L172.9 121.825L176.546 123.154L177.767 120.326L179.982 125.75L183.923 128.008L181.48 129.606L183.334 134.635L178.676 130.81L175.925 130.917Z",
    fill: "#F2AE43"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M182.814 125.126C185.509 128.835 187.475 132.518 188.481 135.465C188.985 136.94 189.24 138.209 189.238 139.193C189.236 140.188 188.974 140.802 188.553 141.108C188.132 141.414 187.467 141.473 186.52 141.168C185.584 140.866 184.456 140.231 183.208 139.296C180.716 137.429 177.821 134.422 175.126 130.713C172.431 127.004 170.465 123.321 169.459 120.375C168.955 118.899 168.7 117.63 168.702 116.646C168.704 115.651 168.966 115.037 169.387 114.731C169.809 114.425 170.473 114.366 171.42 114.671C172.357 114.973 173.485 115.608 174.733 116.543C177.224 118.41 180.119 121.417 182.814 125.126Z",
    stroke: "#F4B85B",
    strokeWidth: 0.811179
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 17.1609,
    ry: 16.4539,
    transform: "matrix(0.887576 0.46066 -0.441816 0.897106 163.983 171.452)",
    fill: "#EBBC73"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 17.1609,
    ry: 16.4539,
    transform: "matrix(0.887576 0.46066 -0.441816 0.897106 165.871 168.798)",
    fill: "#F8D49D"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M178.911 175.741C175.424 182.822 166.656 185.512 159.312 181.7C151.967 177.888 148.879 169.045 152.366 161.964C155.854 154.883 164.621 152.194 171.966 156.006C179.31 159.817 182.398 168.66 178.911 175.741Z",
    stroke: "#F4B85B",
    strokeWidth: 0.811179
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M156.488 172.027L161.303 166.847L158.897 160.627L166.175 162.935L172.295 159.378L171.416 166.389L176.712 171.053L169.777 172.414L166.938 178.879L163.527 172.699L156.488 172.027Z",
    fill: "#F2AE43"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStarCoins, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/star-coins.25dd5a5d.svg";
export { ForwardRef as ReactComponent };